/* eslint-disable no-empty-pattern */
import React from "react";

type Props = {};

function LoadingAnimation({}: Props) {
  const containerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
  };

  return (
    <div style={containerStyle}>
      <div className="flex items-center justify-center h-screen">
        <div className="w-16 h-16 border-t-4 border-solid rounded-full border-primary animate-spin"></div>
      </div>
    </div>
  );
}

export default LoadingAnimation;
